"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoList = exports.InfoCardSimple = void 0;
/* eslint-disable react/prop-types */
var react_1 = __importDefault(require("react"));
var antd_1 = require("antd");
var styled_components_1 = __importDefault(require("styled-components"));
var utils_1 = require("../../utils");
var Text = antd_1.Typography.Text;
var colors = {
    darkblue: "#0F3F6B",
    soft: "#909DA9",
};
var p = utils_1.createPrefixer("Layouts-Cards-InfoCardSimple-");
var classes = {
    title: p(templateObject_1 || (templateObject_1 = __makeTemplateObject(["title"], ["title"]))),
    content: p(templateObject_2 || (templateObject_2 = __makeTemplateObject(["content"], ["content"]))),
};
var Wrapper = styled_components_1.default(antd_1.Row)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding: 1rem;\n  background: white;\n"], ["\n  padding: 1rem;\n  background: white;\n"])));
var InfoCardSimple = function (_a) {
    var children = _a.children, title = _a.title, extra = _a.extra, loading = _a.loading, addonTitleCenter = _a.addonTitleCenter;
    return (react_1.default.createElement(Wrapper, null,
        react_1.default.createElement(antd_1.Col, { xs: 24, className: classes.title },
            react_1.default.createElement(antd_1.Row, { justify: "space-between", align: "top", wrap: false },
                loading ? (react_1.default.createElement(antd_1.Col, { style: {
                        flexGrow: 1,
                        marginRight: "30px",
                        height: "22px",
                        alignItems: "center",
                        display: "flex",
                    } },
                    react_1.default.createElement(antd_1.Skeleton, { paragraph: false, active: true, title: { style: { margin: 0 } } }))) : (react_1.default.createElement(antd_1.Col, null,
                    react_1.default.createElement(antd_1.Row, { align: "middle" },
                        react_1.default.createElement(antd_1.Col, null,
                            react_1.default.createElement(Text, { style: { fontWeight: "bold", fontSize: "16px" } }, title))))),
                addonTitleCenter,
                !loading && react_1.default.createElement(antd_1.Col, null, extra))),
        react_1.default.createElement(antd_1.Col, { xs: 24, className: classes.content }, children)));
};
exports.InfoCardSimple = InfoCardSimple;
InfoCardSimple.classes = classes;
var InfoListWrapper = styled_components_1.default(antd_1.Row)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  &&& {\n    .label {\n      color: ", ";\n      .anticon {\n        color: ", ";\n      }\n    }\n  }\n"], ["\n  &&& {\n    .label {\n      color: ", ";\n      .anticon {\n        color: ", ";\n      }\n    }\n  }\n"])), colors.soft, colors.soft);
var classesInfoList = utils_1.createPrefixer("Layouts-Cards-InfoList-");
var infoListClasses = {
    labelCol: classesInfoList(templateObject_5 || (templateObject_5 = __makeTemplateObject(["labelCol"], ["labelCol"]))),
    dataCol: classesInfoList(templateObject_6 || (templateObject_6 = __makeTemplateObject(["dataCol"], ["dataCol"]))),
    dataColDiv: classesInfoList(templateObject_7 || (templateObject_7 = __makeTemplateObject(["dataColDiv"], ["dataColDiv"]))),
};
var InfoList = function (_a) {
    var list = _a.list, _b = _a.loading, loading = _b === void 0 ? false : _b, _c = _a.style, style = _c === void 0 ? {} : _c, _d = _a.gap, gap = _d === void 0 ? "13px" : _d, className = _a.className, _e = _a.omitLabelIfNotProvided, omitLabelIfNotProvided = _e === void 0 ? true : _e;
    return (react_1.default.createElement(InfoListWrapper, { className: className, style: __assign({ marginTop: "24px" }, style) }, list.map(function (_a) {
        var detail = _a.data, label = _a.label, _b = _a.labelColProps, labelColProps = _b === void 0 ? {} : _b;
        var showLabel = label || !omitLabelIfNotProvided;
        return (react_1.default.createElement(antd_1.Col, { span: 24, style: { marginBottom: "8px" } },
            react_1.default.createElement(antd_1.Row, { gutter: 8, align: "top", wrap: false },
                showLabel && (react_1.default.createElement(antd_1.Col, __assign({}, labelColProps, { className: "label " + infoListClasses.labelCol }), label)),
                react_1.default.createElement(antd_1.Col, { style: { flexGrow: 1 }, className: infoListClasses.dataCol }, loading ? (react_1.default.createElement(antd_1.Skeleton, { paragraph: false, active: true, title: { style: { margin: 0 } } })) : (react_1.default.createElement("div", { style: { marginLeft: showLabel ? gap : 0 }, className: infoListClasses.dataColDiv }, detail))))));
    })));
};
exports.InfoList = InfoList;
InfoList.classes = infoListClasses;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
